import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './components/Navbar';
import Landing from './components/Landing';
import PhotoGallery from './components/PhotoGallery';
import Developer from './components/Developer';
import Login from './components/Login';
import DashboardLayout from './components/dashboard/DashboardLayout';
import DashboardOverview from './components/dashboard/DashboardOverview';
import DashboardPhotos from './components/dashboard/DashboardPhotos';
import DashboardUpload from './components/dashboard/DashboardUpload';
import DashboardSettings from './components/dashboard/DashboardSettings';

const titles = {
  '/': 'fotoSOP - Album Kenangan Sopia',
  '/album': 'Album - fotoSOP',
  '/developer': 'Developer - fotoSOP',
  '/login': 'Masuk - fotoSOP',
  '/dashboard': 'Dashboard - fotoSOP',
  '/dashboard/photos': 'Photos - fotoSOP',
  '/dashboard/upload': 'Upload - fotoSOP',
  '/dashboard/settings': 'Settings - fotoSOP',
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then((res) => setUser(res.data.user))
        .catch(() => {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    document.title = titles[window.location.pathname] || 'fotoSOP';
  });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3 animate-fade-in">
          <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
            <div className="w-5 h-5 border-2 border-primary/20 border-t-primary rounded-full animate-spin" />
          </div>
          <p className="text-xs text-muted-foreground font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Landing page */}
      <Route path="/" element={
        <PublicLayout user={user}>
          <Landing />
        </PublicLayout>
      } />

      {/* Public album */}
      <Route path="/album" element={
        <PublicLayout user={user}>
          <PhotoGallery />
        </PublicLayout>
      } />

      {/* Developer */}
      <Route path="/developer" element={
        <PublicLayout user={user}>
          <Developer />
        </PublicLayout>
      } />

      {/* Login */}
      <Route path="/login" element={
        user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />
      } />

      {/* Dashboard (protected, nested) */}
      <Route path="/dashboard" element={
        user ? <DashboardLayout user={user} setUser={setUser} /> : <Navigate to="/login" />
      }>
        <Route index element={<DashboardOverview />} />
        <Route path="photos" element={<DashboardPhotos />} />
        <Route path="upload" element={<DashboardUpload />} />
        <Route path="settings" element={<DashboardSettings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PublicLayout({ children, user }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar user={user} />
      <main className="flex-1 pt-16 md:pt-0">{children}</main>
    </div>
  );
}

export default App;
